// extracted by mini-css-extract-plugin
module.exports = {"title":"SlideInfo_title__34ynS","buttonContainer":"SlideInfo_buttonContainer__BaDCH"};